import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { useUser } from 'shared/hooks/use-user';
import { LimitKeys } from 'shared/types/limit-keys';
import { UpcomingViewOptions } from 'shared/types/upcoming-view-options';
import { useTheme } from 'styled-components';

export type UpcomingSelectedView = {
  view: UpcomingViewOptions;
  isCalendarAllowed: boolean;
};

export const useUpcomingSelectedView = (): UpcomingSelectedView => {
  const theme = useTheme();
  const user = useUser();

  // Each calendar view is gated on its own limit, so entitlement to any one of them opens the view.
  const { allowed: isCalendarFourDaysAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarFourDays,
    {},
  );
  const { allowed: isCalendarWeekAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarWeek,
    {},
  );
  const { allowed: isCalendarMonthAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarMonth,
    {},
  );

  const isCalendarAllowed =
    isCalendarFourDaysAllowed ||
    isCalendarWeekAllowed ||
    isCalendarMonthAllowed;

  const view =
    (isCalendarAllowed && !theme.isMobile
      ? user?.settings?.upcoming?.webView
      : undefined) ?? UpcomingViewOptions.List;

  return { view, isCalendarAllowed };
};
